import Comparisons from '@containers/Pricing/constants/Comparisons';
import ComparisonDropdown from './components/ComparisonDropdown';
import styles from './styles.module.scss';

const PlanComparison = () => (
  <div className={styles.planComparisonContainer}>
    <div className={styles.title}>Compare what you get across different plans</div>
    <div className={styles.comparisonContainer}>
      {Comparisons.map((comparison) => (
        <ComparisonDropdown
          key={comparison.section}
          section={comparison.section}
          details={comparison.details}
        />
      ))}
    </div>
  </div>
);

export default PlanComparison;
